/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import { Box, Button, Stack } from "@mui/material";
import { addMessage } from "@/src/store/messages/actions.tsx";

export default function ToastStyleguide() {
  return (
    <StyleguideView title={"Variants"}>
      <Stack direction={"column"} spacing={"1.5rem"}>
        <Box>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={() => {
              addMessage({ type: "success", text: "Success toast" });
            }}
          >
            Show Toast Success
          </Button>
        </Box>
        <Box>
          <Button
            variant={"contained"}
            color={"warning"}
            onClick={() => {
              addMessage({ type: "warning", text: "Warning toast" });
            }}
          >
            Show Toast Warning
          </Button>
        </Box>
        <Box>
          <Button
            variant={"contained"}
            color={"error"}
            onClick={() => {
              addMessage({ type: "error", text: "Error toast" });
            }}
          >
            Show Toast Error
          </Button>
        </Box>
      </Stack>
    </StyleguideView>
  );
};
